import {coerceNumberProperty} from '@angular/cdk/coercion';
import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import {GoalSettingService} from 'projects/goal-setting-ui/src/app/services/goal-setting.service';
import { UserService } from '@app-services/user/user.service';
import { AuthService } from '@app-services/auth-service/auth.service';
import { Router } from '@angular/router';
import { clearLocalStorage } from '@app-helpers/functions';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { FirebaseService } from '@app-services/firebase/firebase.service';

@Component({
  selector: 'app-goal-setting-home',
  templateUrl: './goal-setting-home.component.html',
  styleUrls: ['./goal-setting-home.component.css']
})
export class GoalSettingHomeComponent implements OnInit {
  totalGoalSteps:any = 7;
  previousStep:any = 0;
  currentStep:any = 1;
  goalStepProgress:any;
  
  // slider 
  autoTicks = false;
  disabled = false;
  invert = false;
  max = 25000;
  min = 0;
  showTicks = false;
  step = 1000;
  thumbLabel = true;
  value = 0;
  vertical = false;

  // register popup
  registerPopupStatus:boolean = false;
  registerPopupInnerStatus:boolean = false;

  //otp status
  otpStatus: boolean = false;

  // registration success
  registrationLoadingStatus: boolean = false;
  registrationSuccess_Step1: boolean = false;
  registrationSuccess_Step2: boolean = false;
  registrationSuccess_Step3: boolean = false;

  // slider mobile carousel
  pauseOnHover:any = false;
  pauseOnFocus = false;
  mobileSliderStatus: boolean = false;

  questionsData:any;
  userSelectedGrade:any;
  getSelectedGrade:any = 0;
  userSelectedExam:any;
  userSelectedAim:any;
  userSelectedColleges:any =[];
  maxRank:any =25000;
  targetExamName:any;
  rankDividerValues:any = [1,5000,1000,12333];
  minMaxScroreForRank:any;
  lasttName:any;
  firstName:any;
  phoneNumber:any;
  otp1:any;
  otp2:any;
  otp3:any;
  otp4:any;
  userSubjects:any=[]
  selectedSubject:any;
  config = {
    allowNumbersOnly: true,
    length: 4,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      'width': '38px',
      'height': '38px',
      'font-size': '14px'
    }
  };
  userEnteredOtp:any;
  userEntered10Grade:any;
  userEntered12Grade:any;
  isTermsAndConditionsSelected:any = true;
  isWhatsUpConsentChecked:any= true;
  errorMessage:any;
  interval:any;
  timer: number = 60;
  phoneNumberError:any;
  isTenthPercentage:any = true;
  is12Percentage:any= true;
  marksError:any;
  grade13Markserror:any; 
  @ViewChildren('firstNameInputId') firstNameInput: QueryList<ElementRef>;
  @ViewChildren('grade10Input') searchInput: QueryList<ElementRef>;


  constructor(public goalServise:GoalSettingService,    private userService: UserService,private authService: AuthService,public router:Router,private cdr: ChangeDetectorRef, private gaService: GAnalyticsService, private firebaseService: FirebaseService) { }

  ngOnInit(): void {
    clearLocalStorage();
    this.getQuestions();
    this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
  }

 
  // slider
  get tickInterval(): number | 'auto' {
    return this.showTicks ? (this.autoTicks ? 'auto' : this._tickInterval) : 0;
  }
  set tickInterval(value) {
    this._tickInterval = coerceNumberProperty(value);
  }
  private _tickInterval = 1;




  prevGoatStep(){
    if(this.currentStep > 1){
      this.currentStep = this.currentStep - 1;
      this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
      this.previousStep = this.currentStep - 1 ;
      if(this.currentStep ==4 && (this.userSelectedGrade.name=="9th" || this.userSelectedGrade.name=="10th")){
        this.currentStep = 2;
        this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
        this.previousStep =this.currentStep - 1;
      }else if(this.currentStep ==3 &&  this.questionsData[2].data <=0){
        this.currentStep = this.currentStep - 1;
        this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
        this.previousStep = this.currentStep - 1 ;
        this.getColleges();
      }
      if(this.currentStep ==6 && !this.userEntered10Grade){
        this.searchInput.first.nativeElement.focus();
      }
    }
  }
  nextGoatStep(){
    if(this.totalGoalSteps > this.currentStep){
      this.currentStep = this.currentStep + 1;
      this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
      this.previousStep = this.currentStep - 1;
      if(this.currentStep ==3 && (this.userSelectedGrade.name=="9th" || this.userSelectedGrade.name=="10th")){
        this.currentStep = 5;
        this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
        this.previousStep = this.currentStep - 1;
      }else if(this.currentStep ==3 &&  this.questionsData[2].data <=0){
        this.currentStep = this.currentStep + 1;
        this.goalStepProgress = ((this.currentStep / this.totalGoalSteps ) * 100).toFixed(2);
        this.previousStep = this.currentStep - 1;
        this.getColleges()
      }
      if(this.currentStep ==6 && !this.userEntered10Grade) {
        this.searchInput.first.nativeElement.focus();
      }
      
    }
  }
  isNextButtonDisabled(){
    if(this.currentStep==1){
      return !this.userSelectedGrade;

    }else if(this.currentStep==2){
      return !this.userSelectedExam;

    }else if(this.currentStep==3){
      return !this.userSelectedAim;

    }else if(this.currentStep==4){
      return this.userSelectedColleges?.length <=0

    }else if(this.currentStep==5){
      return this.value<=1;

    }
    else{
      return true;
    }
  }
  onGradeSelect(grade:any){
   this.userSelectedGrade = grade;
   this.getSelectedGrade = this.userSelectedGrade.cmsGradeId;
   this.userSelectedAim = null;
   this.userSelectedExam = null;
   this.questionsData[3].data =[];
  }
  onExamSelect(exam:any){
  this.userSelectedExam = exam;
  localStorage.setItem('targetExamName',this.userSelectedExam.name);
  if(this.userSelectedExam.name=='NEET'){
    this.maxRank = 720;
    this.step=1;
    this.value=612;
    this.targetExamName = 'NEET';
  }else{
    this.maxRank = 25000;
    this.value = 1000;
    this.targetExamName = '';
  }
  this.userSelectedAim = null;
  this.questionsData[3].data =[];
  this.rankDividerValues = this.getIntDividedIntoMultiple( this.maxRank,4,100);
  this.getAimsForSelectedGradeAndExam();
  }

  registerPopup(){
    this.registerPopupStatus = !this.registerPopupStatus;
    this.registerPopupInnerStatus = !this.registerPopupInnerStatus;
    this.searchInput.first.nativeElement.blur();
    this.config.disableAutoFocus = false;
    if(this.firstName ==undefined){  
      this.firstNameInput.first.nativeElement.focus();
    }
  }
  onAimSelect(aim:any){
    this.userSelectedAim =aim;
    this.userSelectedColleges=[];
    this.getColleges();
  }
  isCollegeSelected(college:any){
    if(this.userSelectedColleges.length > 0){
      let item:any = this.userSelectedColleges.find((item:any) =>  item.aimCollegeDataId == college.aimCollegeDataId);
      console.log(item)
       return item ? true : false;
    }else{
      return false;
    }

  }
getAimsForSelectedGradeAndExam(){
  this.goalServise.getAimsForSelectedgradeAndExam(this.userSelectedGrade.cmsGradeId,this.userSelectedExam.cmsExamId).subscribe((data:any) => {
      this.questionsData[2].data = data;      
  })
}
getColleges(){
  this.goalServise.getColleges(this.userSelectedAim?.id ? this.userSelectedAim?.id : 1 ,this.userSelectedExam.cmsExamId).subscribe((data:any)=>{
    this.questionsData[3].data = data.colleges;
    console.log('selected colleges',this.userSelectedColleges);
    this.value = data.defaultRank;
    this.getRankData();
  })
}
  registerPopupClose(){
    this.registerPopupInnerStatus = false;
    setTimeout(()=>{
        this.registerPopupStatus = false;
    }, 1000);
  }
onCollegeSelect(event:any,college:any){
if(event.target.checked){
  this.userSelectedColleges.push(college)
}else{
  this.userSelectedColleges =   this.userSelectedColleges.filter((item:any) => item.aimCollegeDataId != college.aimCollegeDataId)
}
this.sendMaxScoreOfSelectedCollges()
}
sendMaxScoreOfSelectedCollges(){
  let maxRank=0;
  if(this.userSelectedExam.name=='NEET'){
    this.userSelectedColleges.map((item:any) => {
      if(item.maxScore > maxRank){
        maxRank = item.maxScore;
      }
    })
  }else{
    this.userSelectedColleges.map((item:any) => {
      if(item.aimRank > maxRank){
        maxRank = item.aimRank;
      }
    })
  }
  this.maxRank = maxRank;
  this.rankDividerValues = this.getIntDividedIntoMultiple( this.maxRank,4,100);
}
getIntDividedIntoMultiple(dividend:any, divisor:any, multiple:any)
{
    var values = [];
    while (dividend> 0 && divisor > 0)
    {
        var a = Math.round(dividend/ divisor / multiple) * multiple;
        dividend -= a;
        divisor--;
        values.push(a);
    }

    return values;
}
onRankInputChange(event:any){

  this.getRankData();
}
getRankData(){
  this.goalServise.getRankData(this.userSelectedExam.cmsExamId,this.value,this.userSelectedAim?.aim ? this.userSelectedAim?.aim: '').subscribe((data:any) => {
    this.minMaxScroreForRank = data;
  })
}
  otpSend(){
    this.otpStatus = !this.otpStatus;
    this.verifyPhone();
  }
  verifyPhone(){
    let payload:any ={
      "isdCode": "+91",
      "phone": this.phoneNumber
  }
    this.goalServise.verifyPhoneNumber(payload).subscribe((data:any) => {
      let generateOtpPayload:any;
      this.setTimerForOTP();
      if(data.existingUser){
       generateOtpPayload ={
        "isdCode": "+91",
        "phone": this.phoneNumber,
    }
      }else{
        generateOtpPayload ={
          "isdCode": "+91",
          "phone": this.phoneNumber,
          "whatsappConsent": this.isWhatsUpConsentChecked,
          "firstName": this.firstName,
          "lastName": this.lasttName,
          "gradeId": this.userSelectedGrade.uamGradeId,
          
          
      }
      }
      this.goalServise.generateOTP(generateOtpPayload).subscribe((data:any) =>{
       
      },(error:any) =>{
     
        this.phoneNumberError = error.error.message;
      })
    },(error:any) =>{
     
      this.phoneNumberError = error.error.message;
    })
  }
  valiDateOtp(){
    let payLoad:any = {
      "isdCode": "+91",
      "phone":  this.phoneNumber,
      "userOtp":  this.userEnteredOtp.toString(),
      "userActivityTrackingDataDto": {
  
      }
  }
    this.goalServise.validateOTP(payLoad).subscribe((userData:any) =>{
      this.registrationSuccess();
      //this.gaService.userLogin(userData?.userDto?.phone);
      setLoggedInUserData(userData, this.userService, this.authService);
      this.updateUserExams(userData);
      this.sedLsqEvents()
    },(error:any) =>{
     
      this.errorMessage = error.error.message;
    })
   
  }
  updateUserExams(userData:any){
   userData.userDto.exams.push({examId:this.userSelectedExam.uamExamId})
   this.goalServise.updateUserExams(userData.userDto,userData.userDto.userId,userData.accessToken).subscribe((data:any) => {
    localStorage.setItem('targetExamName',data.userDto.exams[0].name.replaceAll(' ', '')?.toUpperCase());
    localStorage.setItem('selfLearUamExamId',data.userDto.exams[0].examId);
    setLoggedInUserData(data, this.userService, this.authService);
    this.getSubjects(data);
    this.updateGoalData(data);
   })
  }
  getSubjects(userData:any){
  this.goalServise.getUserSubjects(userData.userDto.userId,this.userSelectedExam.cmsExamId,userData.userDto.subTenant,userData.accessToken).subscribe((subjects:any) =>{
    this.userSubjects = subjects?.data?.childNodes.filter((subject:any) => subject.isChaptersAvailable == true);
   
  })
  }
  changeSelectedSubject(subjecct:any){
    this.selectedSubject = subjecct
  }
  goToSubjectPage(subject: any) {
    localStorage.setItem('selfLearnSelectedSubject', subject.nodeId);
    localStorage.setItem('selfLearnSelectedSubjectName', subject.nodeName);
    const navigationPath = "selfLearn-V2"
    this.router.navigateByUrl(navigationPath);
    const urlParams = { queryParams: { navigateToSelfLearnSubject: true} }
    this.router.navigate([navigationPath], urlParams);
  }
  navigateToHome(){
    this.router.navigate(['/dashboard']);
  }
  getSelectedCollegeIds(){
    let ids:any =[];
    this.userSelectedColleges.map((item:any) =>{
      ids.push(item.aimCollegeDataId)
    })
    return ids;
  }
  getSelectedCollegenames(){
    let ids:any =[];
    this.userSelectedColleges.map((item:any) =>{
      ids.push(item.collegeName)
    })
    return ids;
  }
  updateGoalData(userData:any){
    let payload:any = {  
      "aim": [this.userSelectedAim?.id],
      "college":this.getSelectedCollegeIds(),
      "completed": true,
      "examId": this.userSelectedExam.cmsExamId,
      "gradeId": this.userSelectedGrade.cmsGradeId,
      "tenPercentage": this.isTenthPercentage ?this.userEntered10Grade : 0,
      "tenGpa": !this.isTenthPercentage ?this.userEntered10Grade : 0,
      "twelvePercentage": this.is12Percentage ? this.userEntered12Grade : 0,
      "twelveGpa": !this.is12Percentage ? this.userEntered12Grade : 0,
      "userRank": this.value,
      "score": this.minMaxScroreForRank?.minMarks,
      "response": [
        {
          "qid": 2,
          "questionResponse": {
            "aimCollegeIds": this.getSelectedCollegeIds()
          }
        },
        {
          "qid": 3,
          "questionResponse": {
            "selectedRange": this.value
          }
        },
        {
          "qid": 7,
          "questionResponse": {
            "tenGpa": this.userEntered10Grade,
            "tenthType": this.isTenthPercentage ? "percentage" :"cgpa"
          }
        }
      ],
    }
    this.goalServise.updateGoal(payload,userData.userDto,userData.accessToken).subscribe((data:any) => {

    })
  }
  registrationSuccess(){
    this.registrationLoadingStatus = true;

    // first success
    setTimeout(()=>{
      this.registrationSuccess_Step1 = true;
    }, 500);

    // second success
    setTimeout(()=>{
      this.registrationSuccess_Step2 = true;
    }, 2000);
    setTimeout(()=>{
      this.registrationSuccess_Step1 = false;
    }, 5000);

    // third success
    setTimeout(()=>{
      this.registrationSuccess_Step3 = true;
    }, 5000);
    //this.registrationSuccessStatus = true;

  
    setTimeout(()=>{
      this.registerPopupClose();
    }, 2000);
  }

  mobileSlider(){
    this.mobileSliderStatus = ! this.mobileSliderStatus;
  }
  getQuestions(){
    this.goalServise.getQuestions().subscribe((data:any) => {

      this.questionsData = data;
      console.log( this.questionsData )
    })
  }
  
  onOtpChange(event: any) {
  this.userEnteredOtp = event.toString();
  
  }

  setTimerForOTP(){
    this.interval = setInterval(() => {
      if(this.timer>1)
           this.timer--;
      else{
        this.timer=60;
        clearInterval( this.interval)
      }
    },1000)
  }
  onkeyPress(event:any){
   
    this.marksError = null
    if(this.isTenthPercentage){
      if(event.target.value >100 || isNaN(event.target.value)){
        this.userEntered10Grade='';
        this.marksError = 'Please enter valid percentage'
      }else{
        if( this.countDecimals(this.userEntered10Grade) > 2){
          event.preventDefault();
         let tempValue:any;
         tempValue=  Math.floor(this.userEntered10Grade * 100) / 100;
         if(tempValue){
          this.userEntered10Grade =''; 
          this.userEntered10Grade = 76.87
          this.userEntered10Grade = tempValue;
          const inputElement = event.target;
          inputElement.value = this.userEntered10Grade;
          this.cdr.detectChanges();
          this.marksError = null
         }else {
          this.userEntered10Grade='';
          this.marksError = 'Please enter valid percentage'
         }

    
        }
       
      }
      }else{
        if( event.target.value >10 || isNaN(event.target.value)){
          this.userEntered10Grade='';
          this.marksError = 'Please enter valid CGPA'
        }else{
          if( this.countDecimals(this.userEntered10Grade) > 1){
            event.preventDefault();
            let tempValue:any;
            tempValue= Math.floor(this.userEntered10Grade * 10) / 10;
            if(tempValue){
              this.userEntered10Grade ='';
              this.userEntered10Grade = tempValue
              const inputElement = event.target;
              inputElement.value = this.userEntered10Grade;
              this.cdr.detectChanges();
              this.marksError = null
            }else{
              this.userEntered10Grade='';
              this.marksError = 'Please enter valid CGPA'
            }

          }
         
        }
      }
  }
  onkeyPressGrade12(event:any){
    this.grade13Markserror = null
   
    if(this.is12Percentage){
      if(event.target.value >100 || isNaN(event.target.value) ){
        this.userEntered12Grade='';
        this.grade13Markserror = 'Please enter valid percentage'
      }else{
        if( this.countDecimals(this.userEntered12Grade) > 2){
          event.preventDefault();
          this.userEntered12Grade = Math.floor(this.userEntered12Grade * 100) / 100;
          if(this.userEntered12Grade){
            const inputElement = event.target;
            inputElement.value = this.userEntered12Grade;
            this.cdr.detectChanges();
          }else{
            this.userEntered12Grade='';
            this.grade13Markserror = 'Please enter valid percentage'
          }

        }
       
       
      }
      }else{
        if( event.target.value >10 || isNaN(event.target.value)){
          this.userEntered12Grade='';
          this.grade13Markserror = 'Please enter valid CGPA'
        }else{
          if( this.countDecimals(this.userEntered12Grade) > 1){
            event.preventDefault();
            this.userEntered12Grade =  Math.floor(this.userEntered12Grade * 10) / 10;
            if(this.userEntered12Grade){
              const inputElement = event.target;
              inputElement.value = this.userEntered12Grade;
              this.cdr.detectChanges();
            }else{
              this.userEntered12Grade='';
              this.grade13Markserror = 'Please enter valid percentage'
            }
          }
    
        }
      }
  } 
  countDecimals(num:any){
    var x = num;
    var text = x.toString();
    var index = text.indexOf(".");
 return index ? (text.length - index - 1) : 0;
  } 

  sedLsqEvents(){
   let  payLoad:any ={ 
    mx_Custom_2: this.userSelectedExam.name,  
    mx_Custom_1: Number(this.userSelectedGrade.name.replace(/\D/g, "")),
    mx_Custom_3:this.userSelectedAim?.aim ? this.userSelectedAim?.aim : 'N/A',
    mx_Custom_4:this.getSelectedCollegenames()?.toString()? this.getSelectedCollegenames()?.toString() : 'N/A'
   }
   this.firebaseService.getSqsValue().then((firebaseRSP:any) => {

    this.userService.sendSQSMsgOptim(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,payLoad,317);
  }).catch((e) => {
    console.log(e);
  });
  }

}

export function setLoggedInUserData(data, userService, authService) {
  localStorage.setItem('token', data.accessToken)
  localStorage.setItem('studentid', data.userDto.phone)
        let gradeByName = data?.userDto?.grade?.name?.replace('st', '')?.replace('nd', '')?.replace('rd', '')?.replace('th', '');
        userService.setMobileAndName({
          phone: data.userDto.phone, isdCode: data.userDto.isdCode, firstName: data.userDto.firstName, lastName: data.userDto.lastName,
          whatsappConsent: data.userDto.whatsappConsent, userId: data.userDto.userId, profilePhoto: data.userDto.profilePhoto, grade: Number(gradeByName)
        });
        userService.setUserTypes(data.userDto.userType);
        userService.updateRequestedUserData(data.userDto);
        authService.updateAuthStatus(true);
        userService.setUserRoles(data.userDto.roles);
      if(data?.userDto?.userId){
        let Window  :any= window 
        Window?.heap?.identify(data?.userDto?.userId)
      }
      
}
